/*
 * Warnwesten.de – Globo/Qstomizer UX, 2026-09-04
 *
 * - Prüft sichtbare Globo-Pflichtgruppen statt nicht vorhandener required-Attribute.
 * - Hält den Warenkorbknopf bei einer verfügbaren Variante technisch klickbar.
 *   Fehlende Angaben werden optisch grau dargestellt und per Overlay erklärt.
 * - Ausverkauft-, Ein-Stück- und echte Ladevorgänge bleiben unangetastet.
 * - Zeigt beim Klick ein Overlay mit den konkret fehlenden Angaben.
 * - Ersetzt die technische Qstomizer-Bestätigung durch eine verständliche Statuskarte.
 * - Stellt nach der Qstomizer-Rückkehr die notwendigen Globo-Auswahlen wieder her.
 */
(function () {
  'use strict';

  if (window.__WW_PRODUCT_OPTIONS_ACTIVE__) return;
  window.__WW_PRODUCT_OPTIONS_ACTIVE__ = true;

  var ONLINE_DESIGN_VALUE = 'Design im Online-Designer gestalten';
  var DESIGN_CONFIRMED_VALUE = 'Ich habe das Design über ANPASSEN übermittelt';
  var RETURN_TIMEOUT_MS = 20000;
  var DESIGNER_OPEN_TIMEOUT_MS = 10000;
  var refreshQueued = false;
  var activeModal = null;
  var modalReturnFocus = null;
  var returnedFromDesigner = isQstomizerReturn();
  var DESIGNER_DRAFT_KEY = 'ww-designer-selection-v1';
  var draftFields = new WeakMap();
  var restoreInterrupted = false;
  var applyingDesignerSelection = false;

  var CUSTOMIZER_PROPERTIES = [
    'properties[_customorderid]', 'properties[_customorderkey]',
    'properties[_customimagefront]', 'properties[_customimageback]',
    'properties[_customauth]', 'properties[Custom Image]'
  ];
  var discardedDesignerForms = new WeakSet();

  function printChoice(form) {
    return form && form.querySelector('input[name="Mit oder ohne Druck?"]:checked');
  }

  function printForm(form) {
    if (form && form.querySelector('input[name="Mit oder ohne Druck?"]')) return form;
    var productId = formIdentity(form);
    return productId && toArray(document.querySelectorAll('form.product-form')).find(function (candidate) {
      return formIdentity(candidate) === productId && candidate.querySelector('input[name="Mit oder ohne Druck?"]');
    });
  }

  function withoutPrint(form) {
    var choice = printChoice(printForm(form));
    return Boolean(choice && choice.value === 'Ohne Druck');
  }

  function customizerFields(form) {
    return form ? toArray(form.querySelectorAll('input, textarea, select')).filter(function (field) {
      return CUSTOMIZER_PROPERTIES.includes(field.name);
    }) : [];
  }

  function hasCustomizerDesign(form) {
    return customizerFields(form).some(function (field) { return String(field.value || '').trim(); }) ||
      Boolean(form && form.querySelector('.qstomizer-image-preview')) ||
      Boolean(form && returnedFromDesigner && isQstomizerReturn());
  }

  function designerEntry(form) {
    var productId = formIdentity(form);
    if (!productId) return;
    var container = form.querySelector('#qstomizer-button-block-container, .qsmzimagesContainer');
    if (!container) return;
    var button = container.querySelector('#qstomizer-product-button');
    if (!button) {
      button = document.createElement('a');
      button.id = 'qstomizer-product-button';
      button.textContent = 'Anpassen';
      button.setAttribute('data-ww-fresh-designer', 'true');
      container.appendChild(button);
    }
    if (button.hasAttribute('data-ww-fresh-designer')) {
      var url = new URL('/apps/qstomizer', window.location.origin);
      url.searchParams.set('qstomizer-product-id', productId);
      url.searchParams.set('qstomizer-locale', document.documentElement.lang || 'de');
      var variant = form.querySelector('[name="id"]');
      var quantity = form.querySelector('[name="quantity"]');
      if (variant && variant.value) url.searchParams.set('variantid', variant.value);
      if (quantity && quantity.value) url.searchParams.set('quantity', quantity.value);
      if (button.href !== url.href) button.href = url.href;
    }
    container.classList.add('ww-qstomizer-managed');
  }

  function removeCustomizerFields(form, formData) {
    customizerFields(form).forEach(function (field) { field.remove(); });
    if (formData) CUSTOMIZER_PROPERTIES.forEach(function (name) { formData.delete(name); });
  }

  function clearCustomizerDesign(form) {
    if (!form) return;
    var productId = formIdentity(form);
    var orderIds = customizerFields(form).filter(function (field) {
      return field.name === 'properties[_customorderid]' && field.value;
    }).map(function (field) { return field.value; });
    var forms = toArray(document.querySelectorAll('form')).filter(function (candidate) {
      return candidate === form || (productId && formIdentity(candidate) === productId) ||
        customizerFields(candidate).some(function (field) {
          return field.name === 'properties[_customorderid]' && orderIds.includes(field.value);
        });
    });
    returnedFromDesigner = false;
    restoreInterrupted = true;
    var url = new URL(window.location.href);
    ['id', 'key', 'imf', 'imb', 'auth', 'id_c', 'testQSMZ'].forEach(function (name) { url.searchParams.delete(name); });
    CUSTOMIZER_PROPERTIES.forEach(function (name) { url.searchParams.delete(name); });
    if (url.href !== window.location.href) window.history.replaceState(window.history.state, '', url.href);
    ['orderId', 'orderKey', 'imgFront', 'imgBack', 'auth', 'authDecoded', 'authOrderKey', 'authOrderId'].forEach(function (name) {
      if (Object.prototype.hasOwnProperty.call(window, name)) window[name] = undefined;
    });
    try {
      var snapshot = JSON.parse(window.sessionStorage.getItem(DESIGNER_DRAFT_KEY));
      if (snapshot && snapshot.product === productId) window.sessionStorage.removeItem(DESIGNER_DRAFT_KEY);
    } catch (error) {}
    forms.forEach(function (candidate) {
      discardedDesignerForms.add(candidate);
      draftFields.delete(candidate);
      removeCustomizerFields(candidate);
      toArray(candidate.querySelectorAll('.qsmzimagesContainer, #qstomizer-button-block-container')).forEach(function (container) {
        if (container.querySelector('.qstomizer-image-preview') || container.classList.contains('qsmzimagesContainer')) {
          container.replaceChildren();
          container.classList.remove('qsmzimagesContainer');
          container.removeAttribute('name');
        }
      });
      findInputsByValue(DESIGN_CONFIRMED_VALUE, candidate).forEach(function (field) {
        if (field.checked) {
          field.checked = false;
          field.dispatchEvent(new Event('input', { bubbles: true }));
          field.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      toArray(candidate.querySelectorAll('input[name="properties[Bestätigung Anpassen]"]')).forEach(function (field) {
        field.value = '';
        field.disabled = true;
      });
      designerEntry(candidate);
    });
    queueRefresh();
  }

  function guardUnprintedDesign(form, formData) {
    if (!form) return;
    if (withoutPrint(form) || discardedDesignerForms.has(form)) {
      if (hasCustomizerDesign(form)) clearCustomizerDesign(form);
      removeCustomizerFields(form, formData);
    }
  }

  document.addEventListener('click', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('input[name="Mit oder ohne Druck?"]') || input.value !== 'Ohne Druck') return;
    var form = input.closest('form');
    if (!hasCustomizerDesign(form)) return;
    if (!window.confirm('Ohne Druck bestellen?\n\nDie bereits erstellten Designs werden aus diesem Artikel entfernt und nicht mitbestellt. Mit „Abbrechen“ behalten Sie Ihre Designs und die bisherige Druckauswahl.')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.setTimeout(queueRefresh, 0);
      return;
    }
    clearCustomizerDesign(form);
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('input[name="Mit oder ohne Druck?"]') || input.value !== 'Ohne Druck' || !input.checked) return;
    var form = input.closest('form');
    if (!hasCustomizerDesign(form)) return;
    if (event.isTrusted && !window.confirm('Ohne Druck bestellen? Die bereits erstellten Designs werden aus diesem Artikel entfernt.')) {
      var printed = findInputByValue('Mit Druck', form);
      if (printed) printed.click();
      return;
    }
    clearCustomizerDesign(form);
  }, true);

  document.addEventListener('submit', function (event) {
    guardUnprintedDesign(event.target);
  }, true);


  function formIdentity(form) {
    try {
      var product = JSON.parse(form.querySelector('[data-js-product-json]').textContent);
      return String(product.id);
    } catch (error) { return null; }
  }

  function selectionFields(group) {
    return toArray(group.querySelectorAll('input, select, textarea')).filter(function (field) {
      return field.name && !['hidden', 'file', 'password', 'submit', 'button'].includes(field.type);
    });
  }

  function rememberGroup(form, group) {
    var fields = selectionFields(group).filter(function (field) { return !field.disabled; });
    if (!fields.length) return;
    var remembered = draftFields.get(form) || new Map();
    var choices = fields.filter(function (field) { return field.type === 'radio' || field.type === 'checkbox'; });
    var field = fields[0];
    var key = group.getAttribute('data-element-id');
    if (!key) return;
    remembered.set(key, {
      group: key, name: field.name, type: field.type,
      values: choices.length ? choices.filter(function (choice) { return choice.checked; }).map(function (choice) { return choice.value; })
        : field.tagName === 'SELECT' ? toArray(field.selectedOptions).map(function (option) { return option.value; }) : [field.value]
    });
    draftFields.set(form, remembered);
  }

  function rememberDesignerSelection(form) {
    if (!form || !formIdentity(form)) return;
    toArray(form.querySelectorAll('.gpo-element')).forEach(function (group) {
      if (isRendered(group)) rememberGroup(form, group);
    });
    var quantity = form.querySelector('input[name="quantity"][data-quantity-input]');
    var snapshot = {
      version: 1, product: formIdentity(form), path: window.location.pathname,
      created: Date.now(), quantity: quantity && quantity.validity.valid ? quantity.value : null,
      fields: Array.from((draftFields.get(form) || new Map()).values())
    };
    try { window.sessionStorage.setItem(DESIGNER_DRAFT_KEY, JSON.stringify(snapshot)); } catch (error) {}
  }

  function readDesignerSelection(form) {
    try {
      var snapshot = JSON.parse(window.sessionStorage.getItem(DESIGNER_DRAFT_KEY));
      if (!snapshot || snapshot.version !== 1 || snapshot.product !== formIdentity(form) || snapshot.path !== window.location.pathname ||
          !Number.isFinite(snapshot.created) || Date.now() - snapshot.created > 6 * 60 * 60 * 1000 ||
          !Array.isArray(snapshot.fields)) return null;
      return snapshot;
    } catch (error) { return null; }
  }

  function restoreSelection(form, snapshot) {
    var changed = false;
    var groups = toArray(form.querySelectorAll('.gpo-element'));
    snapshot.fields.forEach(function (saved) {
      var group = groups.find(function (candidate) { return candidate.getAttribute('data-element-id') === saved.group; });
      if (!group || !isRendered(group) || !Array.isArray(saved.values)) return;
      var fields = selectionFields(group);
      if (fields.some(function (field) { return [ONLINE_DESIGN_VALUE, DESIGN_CONFIRMED_VALUE, 'Mit Druck', 'Neues Design erstellen'].includes(field.value); })) return;
      fields = fields.filter(function (field) { return field.name === saved.name && field.type === saved.type && !field.disabled; });
      if (!fields.length) return;
      if (saved.type === 'radio' || saved.type === 'checkbox') {
        if (saved.values.some(function (value) { return !fields.some(function (field) { return field.value === value; }); })) return;
        fields.forEach(function (field) {
          var checked = saved.values.includes(field.value);
          if (field.checked !== checked && (checked || saved.type === 'checkbox')) {
            field.click();
            changed = true;
          }
        });
      } else {
        var field = fields[0];
        if (field.tagName === 'SELECT') {
          if (saved.values.some(function (value) { return !toArray(field.options).some(function (option) { return option.value === value; }); })) return;
          var selected = toArray(field.selectedOptions).map(function (option) { return option.value; });
          if (JSON.stringify(selected) === JSON.stringify(saved.values)) return;
          toArray(field.options).forEach(function (option) { option.selected = saved.values.includes(option.value); });
        } else {
          if (typeof saved.values[0] !== 'string' || field.value === saved.values[0]) return;
          field.value = saved.values[0];
        }
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));
        changed = true;
      }
    });
    var quantity = form.querySelector('input[name="quantity"][data-quantity-input]');
    if (quantity && /^\d+$/.test(snapshot.quantity || '') && Number.isSafeInteger(Number(snapshot.quantity)) && Number(snapshot.quantity) > 0 && quantity.value !== snapshot.quantity) {
      var previous = quantity.value;
      quantity.value = snapshot.quantity;
      if (!quantity.validity.valid) quantity.value = previous;
      else {
        quantity.dispatchEvent(new Event('input', { bubbles: true }));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
        changed = true;
      }
    }
    return changed;
  }

  function recordSelectionChange(event) {
    if (!event.isTrusted || applyingDesignerSelection) return;
    var target = event.target;
    var form = target.closest && target.closest('form.product-form');
    if (!form) return;
    restoreInterrupted = true;
    var group = target.closest('.gpo-element');
    if (group && target.matches('input, select, textarea')) rememberGroup(form, group);
  }

  document.addEventListener('input', recordSelectionChange, true);
  document.addEventListener('change', recordSelectionChange, true);
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('#qstomizer-product-button, #qstomizer-close-btn, .ww-design-card__button');
    if (target) rememberDesignerSelection(target.closest('form') || findRelevantForm(target));
  }, true);

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function findInputsByValue(value, root) {
    return toArray((root || document).querySelectorAll('input')).filter(function (input) {
      return input.value === value;
    });
  }

  function findInputByValue(value, root) {
    return findInputsByValue(value, root)[0] || null;
  }

  function isRendered(element) {
    if (!element || !element.isConnected || element.hidden) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  }

  function getFieldLabel(group) {
    if (group.classList.contains('ww-designer-confirmation-field') || group.hasAttribute('data-ww-designer-required')) {
      return 'Design im Online-Designer gestalten';
    }

    var label = group.querySelector('.gpo-label.required, label.required, .gpo-label');
    var text = label ? label.textContent : 'Pflichtfeld';
    return text
      .replace(/\s*\*+\s*$/, '')
      .replace(/\s*:\s*$/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isOnlineDesignerSelected(root) {
    return findInputsByValue(ONLINE_DESIGN_VALUE, root || document).some(function (input) {
      return input.checked;
    });
  }

  function isRelevantRequiredGroup(group, root) {
    if (group.classList.contains('ww-designer-confirmation-field')) {
      return isOnlineDesignerSelected(root);
    }
    return isRendered(group);
  }

  function getRequiredGroups(form) {
    if (!form) return [];
    return toArray(form.querySelectorAll('.gpo-element')).filter(function (group) {
      var isRequired = Boolean(group.querySelector('.gpo-label.required, label.required'));
      return isRequired && isRelevantRequiredGroup(group, form);
    });
  }

  function isGroupComplete(group) {
    if (group.hasAttribute('data-ww-designer-required')) {
      if (returnedFromDesigner) return true;
      var designerForm = group.closest('form');
      var confirmation = findInputByValue(DESIGN_CONFIRMED_VALUE, designerForm || document);
      return Boolean(confirmation && confirmation.checked);
    }

    var controls = toArray(group.querySelectorAll('input, select, textarea')).filter(function (control) {
      return !control.disabled && control.type !== 'hidden' && control.type !== 'submit' && control.type !== 'button';
    });

    if (!controls.length) return false;

    var choiceControls = controls.filter(function (control) {
      return control.type === 'radio' || control.type === 'checkbox';
    });
    if (choiceControls.length) {
      return choiceControls.some(function (control) { return control.checked; });
    }

    return controls.some(function (control) {
      if (control.type === 'file') {
        return Boolean((control.files && control.files.length) || control.value);
      }
      return String(control.value || '').trim() !== '';
    });
  }

  function getFormState(form) {
    if (!form) return { groups: [], missing: [] };

    toArray(form.querySelectorAll('[data-ww-designer-required]')).forEach(function (group) {
      group.removeAttribute('data-ww-designer-required');
    });

    var onlineInput = findInputsByValue(ONLINE_DESIGN_VALUE, form).find(function (input) {
      return input.checked;
    });
    if (onlineInput) {
      var confirmationInput = findInputByValue(DESIGN_CONFIRMED_VALUE, form);
      var designerAnchor = confirmationInput && confirmationInput.closest('.gpo-element');
      designerAnchor = designerAnchor || onlineInput.closest('.gpo-element');
      if (designerAnchor) designerAnchor.setAttribute('data-ww-designer-required', 'true');
    }

    var groups = getRequiredGroups(form);
    return {
      groups: groups,
      missing: groups.filter(function (group) { return !isGroupComplete(group); })
    };
  }

  function isCartButton(element) {
    if (!element || !element.matches || !element.matches('button, input[type="submit"]')) return false;
    // Ausschließlich echte Produktformular-Buttons erfassen. Eine Erkennung
    // über den sichtbaren Text würde auch das Warenkorb-Symbol im Header als
    // Add-to-Cart-Button behandeln und dort die Globo-Prüfung auslösen.
    return element.matches(
      '.add-to-cart, .gpo-clone-atc-button, .gpo-original-atc-button, button[name="add"], #AddToCart'
    );
  }

  function findRelevantForm(button) {
    var closestForm = button && button.closest ? button.closest('form') : null;
    if (closestForm && closestForm.querySelector('.gpo-container, .gpo-app-container')) return closestForm;

    return toArray(document.querySelectorAll('form')).find(function (form) {
      return form.querySelector('.gpo-container, .gpo-app-container');
    }) || null;
  }

  function getCurrentVariant(form) {
    if (!form) return null;

    var variantInput = form.querySelector('[name="id"]');
    var productJson = form.querySelector('[data-js-product-json]');
    if (!variantInput || !variantInput.value || !productJson) return null;

    try {
      var product = JSON.parse(productJson.textContent || productJson.innerText || '{}');
      var variantId = Number(variantInput.value);
      return (product.variants || []).find(function (variant) {
        return Number(variant.id) === variantId;
      }) || null;
    } catch (error) {
      return null;
    }
  }

  function hasLegitimateButtonLock(button, form) {
    if (!button) return true;

    var text = (button.innerText || button.value || '').toLowerCase();
    var blockedText = [
      'ausverkauft',
      'nicht verfügbar',
      'unavailable',
      'sold out',
      'bereits im warenkorb'
    ].some(function (phrase) {
      return text.indexOf(phrase) !== -1;
    });

    if (blockedText) return true;
    if (button.dataset.limitVariantLocked) return true;
    if (button.matches('.loading, .is-loading, [aria-busy="true"]')) return true;
    if (form && form.getAttribute('data-cart-loading') === 'true') return true;

    var variant = getCurrentVariant(form);
    if (!variant) {
      // Ohne verlässliche Variantendaten niemals einen fremden Sperrzustand lösen.
      return button.disabled || button.classList.contains('disabled');
    }

    return variant.available === false;
  }

  function releaseGloboButtonLock(button, form) {
    var legitimatelyLocked = hasLegitimateButtonLock(button, form);
    button.classList.toggle('ww-atc-clickable', !legitimatelyLocked);
    if (legitimatelyLocked) return;

    button.disabled = false;
    button.removeAttribute('disabled');
    button.classList.remove('disabled', 'is-disabled');
    if (button.getAttribute('aria-disabled') === 'true') {
      button.removeAttribute('aria-disabled');
    }
    button.style.removeProperty('pointer-events');
  }

  function updateValidationState() {
    toArray(document.querySelectorAll('button, input[type="submit"]')).filter(isCartButton).forEach(function (button) {
      var form = findRelevantForm(button);
      var state = getFormState(form);
      var incomplete = state.groups.length > 0 && state.missing.length > 0;

      // Globo setzt den Button bei bestimmten Abhängigkeitsfolgen dauerhaft auf
      // disabled. Bei einer verfügbaren Variante lösen wir nur diese App-Sperre.
      // Die eigene Klickprüfung unten verhindert weiterhin ein unvollständiges
      // Absenden und zeigt stattdessen die gut sichtbare Fehlermeldung.
      if (state.groups.length > 0) releaseGloboButtonLock(button, form);

      button.classList.toggle('ww-atc-incomplete', incomplete);
      if (incomplete) {
        button.setAttribute('data-ww-incomplete', 'true');
        button.setAttribute('data-ww-missing-fields', state.missing.map(getFieldLabel).join(' | '));
        button.setAttribute('title', 'Bitte zuerst alle Pflichtfelder auswählen');
      } else {
        button.removeAttribute('data-ww-incomplete');
        button.removeAttribute('data-ww-missing-fields');
        if (button.getAttribute('title') === 'Bitte zuerst alle Pflichtfelder auswählen') {
          button.removeAttribute('title');
        }
      }
    });
  }

  function closeModal(options) {
    if (!activeModal) return;
    var modal = activeModal;
    activeModal = null;
    modal.classList.remove('ww-modal--visible');
    document.body.classList.remove('ww-modal-open');

    window.setTimeout(function () {
      if (modal.parentNode) modal.parentNode.removeChild(modal);
    }, 200);

    if (options && options.restoreFocus && modalReturnFocus && modalReturnFocus.focus) {
      modalReturnFocus.focus({ preventScroll: true });
    }
  }

  function showModal(options) {
    closeModal();
    modalReturnFocus = document.activeElement;

    var overlay = document.createElement('div');
    overlay.className = 'ww-modal ww-modal--' + (options.kind || 'notice');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'ww-modal-title');

    var panel = document.createElement('div');
    panel.className = 'ww-modal__panel';

    var icon = document.createElement('div');
    icon.className = 'ww-modal__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = options.kind === 'success' ? '✓' : '!';

    var title = document.createElement('h2');
    title.className = 'ww-modal__title';
    title.id = 'ww-modal-title';
    title.textContent = options.title;

    var message = document.createElement('p');
    message.className = 'ww-modal__message';
    message.textContent = options.message;

    panel.appendChild(icon);
    panel.appendChild(title);
    panel.appendChild(message);

    if (options.items && options.items.length) {
      var list = document.createElement('ul');
      list.className = 'ww-modal__list';
      options.items.forEach(function (item) {
        var listItem = document.createElement('li');
        listItem.textContent = item;
        list.appendChild(listItem);
      });
      panel.appendChild(list);
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'ww-modal__button';
    button.textContent = options.buttonText || 'OK';
    button.addEventListener('click', function () {
      closeModal();
      if (options.onClose) options.onClose();
    });
    panel.appendChild(button);
    overlay.appendChild(panel);
    document.body.appendChild(overlay);
    activeModal = overlay;
    document.body.classList.add('ww-modal-open');

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        closeModal({ restoreFocus: true });
      }
    });

    window.requestAnimationFrame(function () {
      overlay.classList.add('ww-modal--visible');
      button.focus();
    });

    if (options.autoClose) {
      window.setTimeout(function () {
        if (activeModal === overlay) closeModal();
      }, options.autoClose);
    }
  }

  function focusMissingGroup(group) {
    if (!group) return;
    var target = group;
    if (group.classList.contains('ww-designer-confirmation-field') || group.hasAttribute('data-ww-designer-required')) {
      var groupForm = group.closest('form');
      target = (groupForm && groupForm.querySelector('.ww-design-card:not([hidden])')) || group;
    }

    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(function () {
      var control = target.querySelector('input:not([type="hidden"]), select, textarea, button');
      if (control && control.focus) control.focus({ preventScroll: true });
    }, 350);
  }

  function showMissingFields(missingGroups) {
    missingGroups.forEach(function (group) {
      group.classList.add('ww-field-missing');
      if (group.classList.contains('ww-designer-confirmation-field') || group.hasAttribute('data-ww-designer-required')) {
        var groupForm = group.closest('form');
        var card = (groupForm && groupForm.querySelector('.ww-design-card:not([hidden])')) || null;
        if (card) card.classList.add('ww-design-card--missing');
      }
    });

    showModal({
      kind: 'error',
      title: 'Bitte Auswahl vervollständigen',
      message: 'Bevor der Artikel in den Warenkorb gelegt werden kann, fehlen noch folgende Angaben:',
      items: missingGroups.map(getFieldLabel),
      buttonText: 'Zur ersten fehlenden Auswahl',
      onClose: function () { focusMissingGroup(missingGroups[0]); }
    });
  }

  function stopDesignerOpening(card) {
    if (!card) return;

    if (card.__wwDesignerOpeningTimer) {
      window.clearTimeout(card.__wwDesignerOpeningTimer);
      card.__wwDesignerOpeningTimer = null;
    }

    var action = card.querySelector('.ww-design-card__button');
    if (!action) return;

    action.classList.remove('ww-design-card__button--loading');
    action.removeAttribute('aria-busy');
    queueRefresh();
  }

  function startDesignerOpening(card, sourceButton) {
    if (!card || !sourceButton) return;

    var action = card.querySelector('.ww-design-card__button');
    if (!action || action.classList.contains('ww-design-card__button--loading')) return;

    action.classList.add('ww-design-card__button--loading');
    action.setAttribute('aria-busy', 'true');
    action.disabled = true;
    setText(action, 'Designer wird geöffnet …');

    // Falls Qstomizer nicht öffnet, darf der Kunde es erneut versuchen.
    card.__wwDesignerOpeningTimer = window.setTimeout(function () {
      stopDesignerOpening(card);
    }, DESIGNER_OPEN_TIMEOUT_MS);

    try {
      sourceButton.click();
    } catch (error) {
      stopDesignerOpening(card);
    }
  }

  function ensureDesignerCard(onlineInput, confirmationInput) {
    var group = onlineInput.closest('.gpo-element');
    var form = onlineInput.closest('form');
    if (!group || !form) return null;

    var confirmationGroup = confirmationInput && confirmationInput.closest('.gpo-element');
    if (confirmationGroup) confirmationGroup.classList.add('ww-designer-confirmation-field');

    var card = form.querySelector('.ww-design-card');
    if (!card) {
      card = document.createElement('div');
      card.className = 'ww-design-card';
      card.innerHTML =
        '<div class="ww-design-card__status" aria-hidden="true"></div>' +
        '<div class="ww-design-card__content">' +
          '<h3 class="ww-design-card__title"></h3>' +
          '<p class="ww-design-card__text"></p>' +
          '<button class="ww-design-card__button" type="button"></button>' +
        '</div>';
      group.insertAdjacentElement('afterend', card);

      card.querySelector('.ww-design-card__button').addEventListener('click', function () {
        var sourceButton = form.querySelector('#qstomizer-product-button') || document.querySelector('#qstomizer-product-button');
        startDesignerOpening(card, sourceButton);
      });
    }

    return card;
  }

  function setText(element, text) {
    if (element && element.textContent !== text) element.textContent = text;
  }

  function updateDesignerCards() {
    findInputsByValue(ONLINE_DESIGN_VALUE, document).forEach(function (onlineInput) {
      var form = onlineInput.closest('form');
      if (!form) return;

      var confirmationInput = findInputByValue(DESIGN_CONFIRMED_VALUE, form);
      var card = ensureDesignerCard(onlineInput, confirmationInput);
      if (!card) return;

      var sourceButton = form.querySelector('#qstomizer-product-button') || document.querySelector('#qstomizer-product-button');
      var sourceContainer = sourceButton && sourceButton.closest('#qstomizer-button-block-container');
      if (sourceContainer) sourceContainer.classList.add('ww-qstomizer-managed');

      var onlineSelected = onlineInput.checked;
      var completed = returnedFromDesigner || Boolean(confirmationInput && confirmationInput.checked);
      card.hidden = !onlineSelected;
      card.classList.toggle('ww-design-card--complete', completed);

      var status = card.querySelector('.ww-design-card__status');
      var title = card.querySelector('.ww-design-card__title');
      var text = card.querySelector('.ww-design-card__text');
      var action = card.querySelector('.ww-design-card__button');
      var opening = action.classList.contains('ww-design-card__button--loading');

      if ((!onlineSelected || completed) && opening) {
        stopDesignerOpening(card);
        opening = false;
      }

      status.hidden = !completed;
      setText(status, '✓');
      setText(title, completed ? 'Design übermittelt' : 'Design jetzt gestalten');
      setText(text, completed
        ? 'Ihr Entwurf wurde übernommen. Wählen Sie jetzt die gewünschten Druckoptionen.'
        : 'Öffnen Sie den Designer. Danach kehren Sie automatisch hierher zurück und wählen die Druckoptionen.');
      setText(action, opening
        ? 'Designer wird geöffnet …'
        : (sourceButton ? (completed ? 'Design ändern' : 'Design gestalten') : 'Designer wird geladen …'));
      action.hidden = completed;
      action.disabled = opening || (!sourceButton && !completed);
    });
  }

  function clearResolvedHighlights() {
    toArray(document.querySelectorAll('.ww-field-missing')).forEach(function (group) {
      if (isGroupComplete(group)) group.classList.remove('ww-field-missing');
    });
    toArray(document.querySelectorAll('.ww-design-card--missing')).forEach(function (card) {
      var cardForm = card.closest('form');
      var confirmationInput = findInputByValue(DESIGN_CONFIRMED_VALUE, cardForm || document);
      if (!isOnlineDesignerSelected(cardForm || document) || (confirmationInput && confirmationInput.checked)) {
        card.classList.remove('ww-design-card--missing');
      }
    });
  }

  function selectedDelivery(form) {
    var choice = form.querySelector('input[name="Mit oder ohne Druck?"]:checked');
    if (!choice) return null;
    var panel = form.querySelector('.delivery_msg');
    if (!panel) return null;
    var text = panel.innerText.replace(/\u00a0/g, ' ');
    var headings = Array.from(text.matchAll(/Geschätzte Lieferzeit\s+(OHNE\s+Druck|MIT\s+DRUCK)[^:]*:/gi));
    var printed = choice.value === 'Mit Druck';
    if (!printed && choice.value !== 'Ohne Druck') return null;
    var index = headings.findIndex(function (heading) { return /MIT/i.test(heading[1]) === printed; });
    if (index < 0) return null;
    var heading = headings[index];
    var section = text.slice(heading.index + heading[0].length, headings[index + 1] ? headings[index + 1].index : text.length);
    var dates = section.match(/\b\d{1,2}\.\d{1,2}\.\d{2,4}\b/g);
    return dates && dates.length === 2 ? dates.join(' - ') : null;
  }

  function updateDelivery(form, formData) {
    if (!form || !form.matches('form.product-form')) return;
    var value = selectedDelivery(form);
    if (!value) return;
    var input = form.querySelector('input[name="properties[Geschätzte Lieferzeit]"]');
    if (input && input.value !== value) input.value = value;
    if (formData) formData.set('properties[Geschätzte Lieferzeit]', value);
  }

  document.addEventListener('formdata', function (event) {
    guardUnprintedDesign(event.target, event.formData);
    updateDelivery(event.target, event.formData);
  }, true);

  function refreshCopyAndDelivery() {
    toArray(document.querySelectorAll('form.product-form')).forEach(function (form) {
      updateDelivery(form);
      toArray(form.querySelectorAll('.gpo-element')).forEach(function (group) {
        var walker = document.createTreeWalker(group, NodeFilter.SHOW_TEXT);
        var node;
        while ((node = walker.nextNode())) {
          var text = node.nodeValue;
          var replacement = text
            .replace('Bitte klicken Sie JETZT auf ANPASSEN (Knopf unterhalb des Formulars), um das Design zu übermitteln, bevor Sie die Fragen in diesem Formular weiter beantworten!', 'Gestalten Sie Ihr Motiv über die Schaltfläche „Design gestalten“. Nach der Rückkehr wählen Sie die Druckoptionen.')
            .replace('Ich habe das Design über ANPASSEN übermittelt', 'Ich habe das Design im Online-Designer übermittelt')
            .replace('Waremkorb', 'Warenkorb')
            .replace('oder hierhier zum Übermitteln ziehen', 'oder Datei hierher ziehen');
          if (replacement !== text) node.nodeValue = replacement;
        }
      });
    });
  }

  function refresh() {
    refreshQueued = false;
    toArray(document.querySelectorAll('form.product-form')).forEach(function (form) {
      if (discardedDesignerForms.has(form)) {
        guardUnprintedDesign(form);
        designerEntry(form);
      }
    });
    refreshCopyAndDelivery();
    updateDesignerCards();
    clearResolvedHighlights();
    updateValidationState();
  }

  function queueRefresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(refresh);
  }

  function isQstomizerReturn() {
    var params = new URLSearchParams(window.location.search);
    return params.has('imf') || params.has('id_c') || window.location.href.indexOf('qstomizeruserimages') !== -1;
  }

  function restoreDesignerReturn() {
    if (!isQstomizerReturn()) return;

    var startedAt = Date.now();
    var hasScrolled = false;
    var stablePasses = 0;
    var timer = window.setInterval(function () {
      applyingDesignerSelection = true;
      try {
      if (restoreInterrupted || Date.now() - startedAt >= RETURN_TIMEOUT_MS) {
        window.clearInterval(timer);
        try { window.sessionStorage.removeItem(DESIGNER_DRAFT_KEY); } catch (error) {}
        return;
      }
      var onlineInputs = findInputsByValue(ONLINE_DESIGN_VALUE, document);
      var onlineInput = onlineInputs.find(function (input) {
        return isRendered(input.closest('.gpo-element'));
      }) || onlineInputs[0];
      if (onlineInput && !onlineInput.checked) onlineInput.click();

      var returnForm = onlineInput && onlineInput.closest('form');
      var confirmationInput = findInputByValue(DESIGN_CONFIRMED_VALUE, returnForm || document);
      if (confirmationInput && !confirmationInput.checked) confirmationInput.click();

      if (confirmationInput && confirmationInput.checked) {
        returnedFromDesigner = true;
        var snapshot = readDesignerSelection(returnForm);
        var changed = snapshot && restoreSelection(returnForm, snapshot);
        stablePasses = changed ? 0 : stablePasses + 1;
        queueRefresh();
        if (stablePasses < 4) return;
        window.clearInterval(timer);
        try { window.sessionStorage.removeItem(DESIGNER_DRAFT_KEY); } catch (error) {}

        window.setTimeout(function () {
          if (!hasScrolled) {
            var target = document.querySelector('.ww-design-card:not([hidden])') || document.querySelector('.gpo-container');
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            hasScrolled = true;
          }
          if (snapshot) return;
          showModal({
            kind: 'success',
            title: 'Design erfolgreich übermittelt!',
            message: 'Wir haben Ihr Design erhalten. Bitte wählen Sie jetzt die gewünschten Druckoptionen aus.',
            buttonText: 'Druckoptionen wählen',
            autoClose: 10000
          });
        }, 150);
      } else if (Date.now() - startedAt >= RETURN_TIMEOUT_MS) {
        window.clearInterval(timer);
      }
      } finally { applyingDesignerSelection = false; }
    }, 500);
  }

  document.addEventListener('click', function (event) {
    window.setTimeout(queueRefresh, 0);
    var button = event.target.closest && event.target.closest('button, input[type="submit"]');
    if (!isCartButton(button)) return;

    var form = findRelevantForm(button);
    guardUnprintedDesign(form);
    updateDelivery(form);
    var state = getFormState(form);
    if (state.groups.length && state.missing.length) {
      // Der Button bleibt technisch klickbar, damit das Overlay auch erscheint.
      // Ein unvollständiges Formular darf dabei nicht an Shopify gesendet werden.
      event.preventDefault();
      event.stopImmediatePropagation();
      showMissingFields(state.missing);
      return;
    }

    var loading = window.WarnwestenCartLoading;
    if (loading && loading.isActive && loading.isActive(form)) {
      // Auch sehr schnelle Mehrfach-Taps sicher abfangen, bevor Globo einen
      // zweiten Warenkorb-Request starten kann.
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    if (loading && loading.start) {
      loading.start(form, button);
    }
  }, true);

  document.addEventListener('change', queueRefresh, true);
  document.addEventListener('input', queueRefresh, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && activeModal) closeModal({ restoreFocus: true });
  });

  var observer = new MutationObserver(queueRefresh);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'checked', 'value', 'disabled', 'aria-disabled']
  });

  refresh();
  [250, 750, 1500, 3000].forEach(function (delay) {
    window.setTimeout(queueRefresh, delay);
  });
  // Sicherheitsnetz für App-Updates, die weder ein DOM-Ereignis noch eine
  // beobachtbare Änderung an den Globo-Feldern auslösen.
  window.setInterval(queueRefresh, 1000);
  restoreDesignerReturn();
})();


